import React from 'react';
import styles from './HatchCTA.module.scss';
import { IconButton } from '../Button/IconButton';
import { HatchingEgg } from '../../icons/hatching-egg';
import { Button } from '../Button/Button';
import { Route } from '../../routing/routes';
import { Link } from 'react-router-dom';
import cls from 'classnames';

export function HatchCTA(props: HatchCTAProps) {
  const button = (
    <Button primary xsmall={true} onClick={props.onClick} className={cls(styles.button)}>
      Hatch Eggs
    </Button>
  );
  return (
    <aside className={styles.box}>
      <div className={styles.body}>
        <IconButton icon={<HatchingEgg />} rounded square />
        <div className={styles.textContainer}>
          <h2 className="m-0 subheading-small text-100">Get a Gribble!</h2>
          <p className="m-0 body-default text-60">
            Hatch your eggs now to obtain your first Gribble!
          </p>
        </div>
        {props.to ? (
          <Link to={props.to} className={styles.link}>
            {button}
          </Link>
        ) : (
          button
        )}
      </div>
    </aside>
  );
}

export type HatchCTAProps = {
  onClick(): void;
  to?: Route;
};
